<template>
    <component
        :is="props.hover ? 'button' : 'div'"
        :type="props.hover ? 'button' : undefined"
        class="flex items-start w-full h-full border text-left text-2xl font-extrabold transition focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-blue-500"
        :class="classes"
    >
        <slot />
    </component>
</template>

<script setup>
import { computed, useSlots } from 'vue';

const props = defineProps({
    health: {
        type: String,
        required: true,
        validator: (value) => ['good', 'bad'].includes(value),
    },
    size: {
        type: Number,
        required: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    hover: {
        type: Boolean,
        default: false,
    },
});

const slots = useSlots();
const hasSlotContent = computed(() => !!slots.default?.());

const classes = computed(() => {
    if (props.disabled) {
        return 'rounded-sm border-dashed border-slate-200 bg-slate-50 cursor-auto';
    }

    return [
        props.hover && 'hover:border-solid cursor-pointer',
        hasSlotContent.value ? 'min-w-16 rounded-lg p-4' : 'min-w-2 rounded-sm',
        props.health === 'bad'
            ? {
                  'bg-slate-200': props.size > 0,
                  'bg-slate-100': props.size <= 0,
                  'text-slate-400': true,
                  'hover:border-slate-300': props.hover,
              }
            : {
                  'bg-sky-400': props.size > 0,
                  'bg-sky-100': props.size <= 0,
                  'text-sky-500': true,
                  'hover:border-sky-500': props.hover,
              },
    ];
});
</script>
